import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";

import security from "../../services/security.js";
import auth from "../../services/auth.js";
import events from "../../services/events.js";

class LeftnavigationController {
  constructor($http, $state, $stateParams, AuthService, EventsService, SecurityService, $rootScope, $scope, $timeout, $location) {
    this.name = "leftnavigation";
    this.$auth = AuthService;
    this.$http = $http;
    this.$scope = $scope;
    this.$state = $state;
    this.$location = $location;
    this.$timeout = $timeout;
    this.$stateParams = $stateParams;
    this.$events = EventsService;
    this.$security = SecurityService;
    this.currentUser = this.$auth.getUserData();
    this.$rootScope = $rootScope;

    //this.heightOfModal  = this.$window.innerHeight - 73;

    var _this = this;

    //this.decideActiveTab();
  }

  switchTabs(index) {
    this.$timeout(() => {
      $("#jobble-side-bar-nav ul li.active").removeClass("active");
      $("#jobble-side-bar-nav ul li:nth-child(" + index + ")").addClass("active");
    });

    this.initLoader(index);
  }

  decideActiveTab() {
    if (this.$location.$$url === "/jobs-dashboard") {
      this.switchTabs(1);
    } else if (this.$location.$$url === "/receipts") {
      this.switchTabs(3);
    } else if (this.$location.$$url === "/teams") {
      this.switchTabs(5);
    } else if (this.$location.$$url === "/inbox") {
      this.switchTabs(4);
    }
  }

  initLoader(index) {
    if (index === 1) {
      if (this.$location.$$url === "/jobs-dashboard") {
        return;
      }
    }

    this.$timeout(() => {
      this.$rootScope.$emit("InitJobsDashboardLoader", {});
    });

    this.setLoader();
    this.sendUser(index);
  }

  sendUser(index) {
    if (index === 5) {
      this.$state.go("teams");
    } else if (index === 3) {
      this.$state.go("transactionhistory");
    } else if (index === 1) {
      this.$state.go("jobsdashboard");
    } else if (index === 4) {
      this.$state.go("inbox");
    } else if (index === 2) {
      this.$state.go("postashiftwalkthrough");
    }

    this.unSetLoader();
  }

  setLoader() {
    var _this = this;

    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;

    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }
}

LeftnavigationController.$inject = ["$http", "$state", "$stateParams", "auth", "events", "security", "$rootScope", "$scope", "$timeout", "$location"];

export default LeftnavigationController;



// WEBPACK FOOTER //
// ./client/app/common/leftnavigation/leftnavigation.controller.js